import { words, getInitialConfigureState, stateKeysToSetAddress } from './globalState';
import { loadDeck, handleClickChallengeDuel } from './monadomCore';
import {
  certificationWithKey,
  setSignatureByAddressMain,
  getAddressFromKeyNW,
} from './keysAndSigning';
import { getBalancesMonapartyKOM, getAssetInfo } from './blockchain';
import { syncHttpRequest2, devLog } from './utils';

// 「ログイン」ボタン押下 HANDLE CLICK LOGIN
async function handleClickLogin({
  dispatch,
  navigate,
  popupLayer,
  keyPairs,
  keyPairsInPoolAll = {},
  sessionToOverride = {},
  activeAddressCandidate = null,
  mode,
  login,
  walletType,
  session,
  marginOfSessionTime,
  assetInfos,
  monacards,
  network,
  clientParameters,
  language,
}) {
  let request = {};
  let messages = {};
  let certifications = [];
  const popupLayerNext = (popupLayer !== undefined && popupLayer !== null) ? (popupLayer + 1) : 0;
  const now = Date.now();

  // state固定
  const stateFixed = {
    // state.login.addressMain は廃止予定。
    // addressMain: login.addressMain,
    // signatureVersion: state.config.clientParameters.signatureVersion.login,
    signatureVersion: '1',
    // addressCheck: state.addressCheck,
    walletType: walletType,
    addressCheck: 'off',
  };

  devLog('session', JSON.stringify(session));
  devLog('session keys', JSON.stringify(Object.keys(session)));

  // セッション固定

  for (const address of Object.keys(session)) {
    stateFixed[address] = {
      sessionId: session[address].sessionId,
      expirationOfSession: session[address].expirationOfSession,
    };
  }

  // セッションのオーバーライド

  const addressesOverridden = Object.keys(session);

  for (const address of Object.keys(sessionToOverride)) {
    if (stateFixed[address] === undefined) {
      stateFixed[address] = {};
      addressesOverridden.push(address);
    }

    stateFixed[address].sessionId = sessionToOverride[address].sessionId;
    stateFixed[address].expirationOfSession = sessionToOverride[address].expirationOfSession;
  }

  // 有効なセッションに絞り込む。

  for (const address of addressesOverridden) {
    if (stateFixed[address].expirationOfSession >= now + (marginOfSessionTime ?? 60000)) {
      certifications.push({
        address: address,
        sessionId: stateFixed[address].sessionId,
      });
    }
  }

  // アドレスが指定されており、そのアドレスのセッションが存在しない、または、期限が切れていれば、署名する。(キープール or Mpurse)
  // Mpurseの場合、アドレスが指定されていない場合は、アクティブなアドレスで代替するかもしれない。(アドレスチェックモードに依る。)
  // keyPairsが渡された場合(2周目)、keyPairsの先頭の鍵で試みる。アドレスが指定されていない場合は、先頭のアドレスで代替するかもしれない。(アドレスチェックモードに依る。)

  // const keyPairsInPool = getValidKeyPairs({ dispatch, keyPairs: keyPairsInPoolAll });

  if (keyPairs !== undefined && keyPairs !== null) {
    certificationWithKey({ dispatch, keyPairs, messageType: 'login', stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, signingMode: 'allKeys', network, language });
    // certificationWithKey({ dispatch, keyPairs, messageType: 'login', stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, signingMode: 'firstKey', network, language });
  }
  // satate.login.addressMain は廃止予定。もし、キープールの鍵でログインするのであれば、対象は全部だ。
  // else if (
  //   stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
  //   keyPairsInPool[stateFixed.addressMain]?.keyPair !== undefined
  // ) {
  //   certificationWithKey({ dispatch, keyPairs: [ keyPairsInPool[stateFixed.addressMain].keyPair ], messageType: 'login', stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, signingMode: 'matchedKey', network, language });
  // }
  else if (stateFixed.walletType === 'mpurse') {
    await setSignatureByAddressMain({ dispatch, stateFixed, certifications, clientTime: now, extendedCertificationProperties: null, messageType: 'login', language });
  }

  // 対象がなかったり、addressMainが指定されているにも関わらずcertificationsに含まれていなかった場合は戻る。ただし、KeyPairsが渡されていない場合は、鍵を要求する。

  if (
    certifications.length === 0
    // state.login.addressMain は廃止予定。
    // ||
    // stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '' &&
    // !certifications.map( certification => certification.address ).includes(stateFixed.addressMain)
  ) {
    if (keyPairs === undefined || keyPairs === null) {
      if (stateFixed.walletType === 'nfc') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.touchWithYourKeyCard[language] });
        return {
          status: 'rejected',
          message: 'nfcRequired',
        };
      }
      else if (stateFixed.walletType === 'qr') {
        dispatch({ type: 'setNotification', key: 'notification', value: words.scanYour2DBarcode[language] });
        return {
          status: 'rejected',
          message: 'bcRequired',
        };
      }
    }

    // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToLogin[language] });
    // return { status: 'rejected' };
    throw new Error(JSON.stringify({ error: 'noCertificationOrNoCertificationForAddressMain', notification: 'failedToLogin' }));
  }

  request.body = JSON.stringify({
    "body": {
      "certifications": certifications,
      "mode": mode,
    }
  });

  request.url = 'https://' + process.env.REACT_APP_MAIN_API_DOMAIN + '/login';
  request.method = 'POST';

  messages = {
  };

  dispatch({ type: 'setState', key: 'accessing', value: true });

  const response = await syncHttpRequest2(request, 'user', undefined, undefined, messages, dispatch);

  dispatch({ type: 'setState', key: 'accessing', value: false });

  const body = response.body;
  const addresses = Object.keys(body ?? {});

  if ( response.status !== 'fulfilled' ) {
    // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToLogin[language] });
    // return { status: 'rejected' };
    throw new Error(JSON.stringify({ error: 'failedToLogin', notification: 'failedToLogin' }));
  }

  let loginAddressCount = {};
  if ( response.status === 'fulfilled' && body !== undefined && body !== null) {
    loginAddressCount.signature = addresses
    .filter( address => body[address].certificatedBy === 'signature' )
    .length;

    loginAddressCount.sessionId = addresses
    .filter( address => body[address].certificatedBy === 'sessionId' )
    .length;

    loginAddressCount.none = addresses
    .filter( address => body[address].certificatedBy === 'none' )
    .length;

    loginAddressCount.success = loginAddressCount.signature + loginAddressCount.sessionId;
    loginAddressCount.failure = loginAddressCount.none;
    loginAddressCount.total = loginAddressCount.success + loginAddressCount.failure;
  }
  else {
    loginAddressCount = {
      signature: null,
      sessionId: null,
      none: null,
      success: null,
      failure: null,
      total: null,
    };
  }

  let certificationsToOverride = [];

  for (const address of addresses) {
    // 署名した場合もろもろ更新
    if (body[address]['certificatedBy'] === 'signature') {

      // session更新
      dispatch({ type: 'setStateMultiLayers', keys: ['session', address],
        value: {'sessionId': body[address]['sessionId'], 'expirationOfSession': body[address]['expirationOfSession']} });

      // certification設定
      certificationsToOverride.push({ addressMain: address, sessionId: body[address].sessionId });
    }
    else if (body[address]['certificatedBy'] === 'none') {
      dispatch({ type: 'setStateMultiLayers', keys: ['session', address], value: { expirationOfSession: 0 } });
    }

    // MONA残高・カード関連情報取得
    if (body[address]['certificatedBy'] === 'signature' || body[address]['certificatedBy'] === 'sessionId') {

      // 保有アセット取得
      getBalancesMonapartyKOM({ dispatch, address, clientParameters })
      .then( (result) => {
        let assets;

        if (result.status === 'fulfilled') {
          const balance = result.body;
          assets = Object.keys(balance);
        }
        else {
          throw new Error(result.error);
        }

        // アセット情報取得
        return getAssetInfo({ dispatch, assets, assetInfos, clientParameters });
      })
      .then( (result) => {
        let assetInfo;

        if (result.status === 'fulfilled') {
          // eslint-disable-next-line no-unused-vars
          assetInfo = result.body;
        }
        else {
          throw new Error(result.error);
        }

        // // モナカード情報取得
        // const assetCommons = Object.keys(assetInfo)
        // .filter( asset => {
        //   try {
        //     return JSON.parse(assetInfo[asset]?.description).monacard === undefined;
        //   }
        //   catch (error) {
        //     return true;
        //   }
        // })
        // .map( asset => assetInfo[asset].asset_longname === null ? asset : assetInfo[asset].asset_longname );

        // getMonacard({ dispatch, assets: assetCommons, monacards });
      })
      .catch( (error) => {
        // stateFixed.addressMainだったら、エラー＆再ログインしてください通知。
      });

      // // MONA残高取得

      // getAddressInfo({ clientParameters, address })
      // .then( (result) => {
      //   if (result.status === 'fulfilled') {
      //     const balance = result.body.balance;
      //     dispatch({ type: 'setStateMultiLayers', keys: ['balance', 'mona', address], value: balance });
      //   }
      //   else {
      //     devLog('failed to get address info.');
      //     // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
      //   }
      // });

      // // オウンドアセット情報取得
      // getOwnedAssets({ dispatch, address, clientParameters })
      // .then( (result) => {
      //   if (result.status === 'fulfilled') {
      //   }
      //   else {
      //     devLog('failed to get owned asset.');
      //     // dispatch({ type: 'setNotification', key: 'notification', value: words.failedToSendMona[language] + '3.5' });
      //   }
      // });

      // let activeCertification;

      // if (stateFixed.addressMain !== undefined && stateFixed.addressMain !== null && stateFixed.addressMain !== '') {
      //   if  (response.body[stateFixed.addressMain].certificatedBy === 'signature') {
      //     activeCertification = {
      //       address: stateFixed.addressMain,
      //       sessionId: response.body[stateFixed.addressMain].sessionId,
      //       expirationOfSession: response.body[stateFixed.addressMain].expirationOfSession,
      //     };
      //   }
      // }

      // const result = await handleClickGetPointSum(state, dispatch, activeCertification);
      // devLog('point sum', JSON.stringify(result.body));
    }
  }

  // デッキ取得
  loadDeck({
    session,
    dispatch,
    certificationsToOverride,
    marginOfSessionTime,
  });

  // デュエル中かどうかで大きく分岐

  let activeAddress;
  const addressOnDuel = Object.keys(response.body).find( address => response.body[address].duelistStatus === 'onDuel');

  if (addressOnDuel !== undefined && addressOnDuel !== null) {
    const responseBodyOnDuel = response.body[addressOnDuel];

    // アクティブアドレスを設定
    activeAddress = addressOnDuel;

    // 基本情報をconfigureにセット
    dispatch({ type: 'setState', key: 'configure', value: responseBodyOnDuel.basicInformation });

    // 各種stateにアクティブアドレスをセット
    for (const keys of stateKeysToSetAddress) {
      dispatch({ type: 'setStateMultiLayers', keys: keys, value: activeAddress });
    }

    // デュエル画面に遷移
    handleClickChallengeDuel({ navigate, gameMode: responseBodyOnDuel.gameMode, difficultyMode: responseBodyOnDuel.difficultyMode });
  }
  else {
    // ユーザー未登録、規約未同意の場合は、対象アドレスリストをポップアップで表示する。

    const addressesThatRequireUserRegistration = addresses.filter( address => body[address].applicationMessage === 'not accept TAC yet.');
    const addressesThatRequireAgreementOfTAC = addresses.filter( address => body[address].applicationMessage === 'you must accept the terms and conditions of the current version.');

    const basicInformationThatRequiresAgreementOfTAC = {};
    const applicationMessageParameterThatRequiresAgreementOfTAC = {};
    for (const address of addressesThatRequireAgreementOfTAC) {
      basicInformationThatRequiresAgreementOfTAC[address] = body[address].basicInformation;
      applicationMessageParameterThatRequiresAgreementOfTAC[address] = body[address].applicationMessageParameter;
    }

    if (addressesThatRequireUserRegistration.length > 0 || addressesThatRequireAgreementOfTAC.length > 0) {
      const popup = {
        type: 'registrationAndAgreementListPopup',
        body: {
          addressesThatRequireUserRegistration,
          addressesThatRequireAgreementOfTAC,
          basicInformationThatRequiresAgreementOfTAC,
          applicationMessageParameterThatRequiresAgreementOfTAC,
        },
      };

      dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayerNext], value: popup });
    }

    // アクティブアドレスを設定

    if (activeAddressCandidate !== undefined && activeAddressCandidate !== null && activeAddressCandidate !== '') {
      if (
        (body?.[activeAddressCandidate]?.basicInformation !== undefined && body[activeAddressCandidate].basicInformation !== null) &&
        (body?.[activeAddressCandidate]?.certificatedBy === 'signature' || body?.[activeAddressCandidate]?.certificatedBy === 'sessionId')
      ) {
        activeAddress = activeAddressCandidate;
      }
      else {
        activeAddress = null;
      }
    }
    else if (keyPairs !== undefined && keyPairs !== null && keyPairs.length >= 1) {
      const activeKeyPair = keyPairs.find( keyPair => {
        const address = getAddressFromKeyNW({ dispatch, keyPair, language, network });
        return (
          (body?.[address]?.basicInformation !== undefined && body[address].basicInformation !== null) &&
          (body?.[address]?.certificatedBy === 'signature' || body?.[address]?.certificatedBy === 'sessionId')
        );
      });

      activeAddress = activeKeyPair ? getAddressFromKeyNW({ dispatch, keyPair: activeKeyPair, language, network }) : null;
    }
    else if (stateFixed.addressMpurse !== undefined && stateFixed.addressMpurse !== null && stateFixed.addressMpurse !== '') {
      if (
        (body?.[stateFixed.addressMpurse]?.basicInformation !== undefined && body[stateFixed.addressMpurse].basicInformation !== null) &&
        (body?.[stateFixed.addressMpurse]?.certificatedBy === 'signature' || body?.[stateFixed.addressMpurse]?.certificatedBy === 'sessionId')
      ) {
        activeAddress = stateFixed.addressMpurse;
      }
      else {
        activeAddress = null;
      }
    }
    else {
      activeAddress = null;
    }

    // 各種stateにアクティブアドレスをセット
    for (const keys of stateKeysToSetAddress) {
      dispatch({ type: 'setStateMultiLayers', keys: keys, value: activeAddress ?? '' });
    }

    if  (activeAddress !== undefined && activeAddress !== null) {
      // 基本情報をconfigureにセット
      dispatch({ type: 'setState', key: 'configure', value: body[activeAddress].basicInformation });

      // ログインポップアップを消す
      if (popupLayer !== undefined && popupLayer !== null) {
        dispatch({ type: 'setStateMultiLayers', keys: ['popup', popupLayer], value: { type: null, body: null } });
      }
    }
    else {
      dispatch({ type: 'setState', key: 'configure', value: getInitialConfigureState() });
    }
  }

  return { ...response, activeAddress, loginAddressCount };
}

export {
  handleClickLogin,
};